<script setup lang="ts">
defineProps<{
	icon: string;
}>();
</script>

<template>
	<DIcon :name="icon" :aria-label="icon" />
</template>
